import { render, staticRenderFns } from "./private-messaging.vue?vue&type=template&id=34030d50&scoped=true&"
import script from "./private-messaging.vue?vue&type=script&lang=js&"
export * from "./private-messaging.vue?vue&type=script&lang=js&"
import style0 from "./private-messaging.vue?vue&type=style&index=0&id=34030d50&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34030d50",
  null
  
)

export default component.exports